import cx from "classnames";
import { memo, useMemo } from "react";
import { generateColor } from "@/helpers/generateColor";
import { getInitials } from "@/helpers/getInitials";
import styles from "./PresentationMembers.module.scss";

type UserAvatarProps = {
    name: string;
    token: string;
    sessionUID: string;
    isPresenter: boolean;
    isCurrentUser?: boolean;
};

export const UserAvatar = memo(
    ({ name, token, sessionUID, isPresenter, isCurrentUser }: UserAvatarProps) => {
        const color = useMemo(
            () => generateColor(isCurrentUser ? sessionUID : token || sessionUID),
            [isCurrentUser, token, sessionUID],
        );

        return (
            <div className={styles.barPanelRightUsersItem}>
                <div
                    className={cx(
                        styles.barPanelRightUsersItemView,
                        isPresenter && styles.barPanelRightUsersItemIndicatorSelected,
                    )}
                    style={{ backgroundColor: color }}
                >
                    {getInitials(name)}
                </div>
            </div>
        );
    },
);
